import { useNavigate, useRouterState } from "@tanstack/react-router";

import { shouldShowDock } from "./dockVisibility";
import { RecordingDock } from "./index";
import { useRecordingDock } from "./store/useRecordingDock";

/**
 * Decides when the floating recording dock shows and wires its case-aware
 * navigation. Mounted in Layout, above the router Outlet.
 */
export const AppRecordingDock = () => {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const isActive = useRecordingDock((s) => s.isActive());
  const caseNumber = useRecordingDock((s) => s.caseNumber);
  const controls = useRecordingDock((s) => s.controls);
  const transcriptViewActive = useRecordingDock((s) => s.transcriptViewActive);
  const requestReturnToTranscript = useRecordingDock(
    (s) => s.requestReturnToTranscript
  );

  if (!shouldShowDock({ isActive, caseNumber, pathname, transcriptViewActive }))
    return null;

  const goToSession = () => {
    if (!caseNumber) return;
    // Ask the scribe page (if mounted) to switch to the Transcript section so
    // the live view shows, then navigate to the scribe tab.
    requestReturnToTranscript();
    navigate({ to: `/report-studio/${caseNumber}/assessment-scribe` });
  };

  return (
    <RecordingDock
      onReturnToSession={goToSession}
      onFinish={() => {
        // Stop + save via the live session, then surface the owning case's
        // scribe tab so the completion/summarize UI is visible.
        controls.stop();
        goToSession();
      }}
    />
  );
};
